import { useCallback, useMemo, useState } from 'react';
import dynamic from 'next/dynamic';
import { ThemeMode } from 'typings/theme';
import { MoversRemoteComponent } from 'movers/main';
import useMarketMover from 'global/Datafeed/UseMarketMover/useMarketMover';
import { useRouter } from 'next/router';
import { MarketMoverBatch } from '@stockbitgroup/protos/financial/order_trade/entity/v1/market_mover_pb';
import {
  MapMoverEnum,
  convertMoverWStoAPI,
  convertMoversFilterListToEnum,
} from './utils';
import { MoverFilterType, MoverType } from '../../../@types/movers';
import Loader from './Loader';

const MoversRemote = dynamic(() => import('movers/main'), {
  ssr: false,
  loading: () => <Loader />,
}) as MoversRemoteComponent;

interface MoversFeatureProps {
  featureKey: string;
  filter: MoverFilterType[];
  setFilter: (filter: MoverFilterType[]) => void;
}

const MoversFeature = ({
  featureKey,
  filter,
  setFilter,
}: MoversFeatureProps) => {
  const router = useRouter();

  const [data, setData] = useState(undefined);
  const [type, setType] = useState<MoverType>('MOVER_TYPE_TOP_VALUE');

  const request = useMemo(
    () => ({
      filterStocks: convertMoversFilterListToEnum(filter),
      moverType: MapMoverEnum[type],
    }),
    [type, filter],
  );

  const onMessageCallback = useCallback((batch: MarketMoverBatch) => {
    setData(convertMoverWStoAPI(batch));
  }, []);

  const onClickPreview = (symbol: string) => {
    if (router.pathname.includes('/chartbit')) {
      router.push(`/symbol/${symbol}/chartbit`);
    } else {
      router.push(`/symbol/${symbol}`);
    }
  };

  useMarketMover(featureKey, request, onMessageCallback);

  return (
    <MoversRemote
      platform="web"
      websocketData={data}
      themeMode={ThemeMode.Light}
      type={type}
      filter={filter}
      portfolioList={[]}
      setType={setType}
      setFilter={setFilter}
      handleClickBuy={null}
      handleClickSell={null}
      handleClickPreview={(symbol) => onClickPreview(symbol)}
      handleClickRow={(symbol) => onClickPreview(symbol)}
    />
  );
};

export default MoversFeature;
